// Extracted verbatim from the v3 monolith (see BIRDSEYE.md module split plan).

export var PF_NS = 'pf';
export var PF_VERSION = '4.0.0';
export var DATA_WRAPPER = '[data-pf="wrapper"]';
export var DATA_FILTERS_WRAPPER = '[data-pf="filters-wrapper"]';
export var DATA_LIST = '[data-pf="list"]';
export var DATA_ITEM = '[data-pf="item"]';
export var DATA_FIELD = '[data-pf-field]';
export var DATA_FILTER = '[data-pf-filter]';
export var DATA_SEARCH = '[data-pf-search]';
export var DATA_RESET = '[data-pf-reset]';
export var DATA_EMPTY = '[data-pf-empty]';
export var DATA_LOADING = '[data-pf-loading]';
export var DATA_COUNT = '[data-pf-count]';
export var DATA_PAGE = '[data-pf-page]';
export var DATA_LOAD_BUTTON = '[data-pf-load-button]';
export var DATA_LOGIC_TOGGLE = '[data-pf-logic-toggle]';
export var DATA_TAGS = '[data-pf-tags]';
export var DATA_TAG_TEMPLATE = '[data-pf-tag-template]';
export var DATA_TAG_TEXT = '[data-pf-tag-text]';
export var DATA_TAG_REMOVE = '[data-pf-tag-remove]';
export var DATA_TAG = '[data-pf-tag]';
export var DATA_FACET_COUNT = '[data-pf-facet-count]';
export var ANIMATION_MODES = ['none', 'flip', 'gsap'];
export var VIEW_MODES = ['pagination', 'loadmore', 'renderall', 'infinite'];
export var LOAD_MODES = ['none', 'manual', 'auto', 'all'];

// data-pf-preset: vetted wrapper-config bundles. Explicit data-pf-* attributes always
// override a preset's value. `load: 'all'` fetches every native Webflow pagination page
// (the >100-item loader) — presets never disable native pagination; they rely on it.
export var PRESETS = {
  // Large filtered CMS collection, numbered pages. The safe default for real filters.
  'filtered-collection': { mode: 'pagination', pagesize: 12, load: 'all' },
  // Same full load, "Load more" button display.
  'load-more': { mode: 'loadmore', pagesize: 12, load: 'all' },
  // Same full load, infinite scroll display.
  'infinite': { mode: 'infinite', load: 'all' },
  // Small collection (< ~100 items, no cross-page filtering): lazy load.
  'simple': { mode: 'pagination', pagesize: 12, load: 'auto' },
};
export var ANIMATION_PRESETS = {
  smooth: {
    duration: 260,
    stagger: 18,
    flipEasing: 'cubic-bezier(0.22, 1, 0.36, 1)',
    gsapEasing: 'power3.out',
    fadeIn: true,
    y: 8,
    enterScaleFrom: 1,
    enterScaleTo: 1,
    moveScaleFrom: 1,
    moveScaleTo: 1,
    enterBlurFrom: 0,
    enterBlurTo: 0,
  },
  snappy: {
    duration: 170,
    stagger: 8,
    flipEasing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
    gsapEasing: 'power2.out',
    fadeIn: true,
    y: 4,
    enterScaleFrom: 1,
    enterScaleTo: 1,
    moveScaleFrom: 1,
    moveScaleTo: 1,
    enterBlurFrom: 0,
    enterBlurTo: 0,
  },
  soft: {
    duration: 360,
    stagger: 22,
    flipEasing: 'cubic-bezier(0.16, 1, 0.3, 1)',
    gsapEasing: 'power4.out',
    fadeIn: true,
    y: 14,
    enterScaleFrom: 0.985,
    enterScaleTo: 1,
    moveScaleFrom: 1,
    moveScaleTo: 1,
    enterBlurFrom: 2,
    enterBlurTo: 0,
  },
  pop: {
    duration: 230,
    stagger: 12,
    flipEasing: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
    gsapEasing: 'back.out(1.2)',
    fadeIn: true,
    y: 10,
    enterScaleFrom: 0.94,
    enterScaleTo: 1,
    moveScaleFrom: 0.992,
    moveScaleTo: 1,
    enterBlurFrom: 0,
    enterBlurTo: 0,
  },
  drift: {
    duration: 420,
    stagger: 26,
    flipEasing: 'cubic-bezier(0.19, 1, 0.22, 1)',
    gsapEasing: 'expo.out',
    fadeIn: true,
    y: 22,
    enterScaleFrom: 0.98,
    enterScaleTo: 1,
    moveScaleFrom: 1,
    moveScaleTo: 1,
    enterBlurFrom: 4,
    enterBlurTo: 0,
  },
};
